const token = localStorage.getItem('token');

export const get_banks = async () => {
  try {
    const url = `${process.env.REACT_APP_API_GCOM_URL}/type-bank`;
    const params = {
      method: 'GET',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const post_bank = async (data) => {
  try {
    const url = `${process.env.REACT_APP_API_GCOM_URL}/type-bank`;
    const params = {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const update_bank = async (data) => {
  try {
    const id = data._id || data.id;
    const url = `${process.env.REACT_APP_API_GCOM_URL}/type-bank/${id}`;
    const params = {
      method: 'PATCH',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const delete_bank = async (data) => {
  try {
    const id = data._id || data.id;
    const url = `${process.env.REACT_APP_API_GCOM_URL}/type-bank/${id}`;
    const params = {
      method: 'DELETE',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}
